export const MODULE_FORM_ID = 'module-form';
